import { Fragment } from 'react'
import styled from 'styled-components'
import Transaction from './Transaction'
import Colors from '../../../../../constants/Colors'

const SlipsComponent = ({ order, slips, setSlips, setOrders, setRemainingAmount, fetchOrdersByStatus }) => {
  if (slips?.length === 0) return false

  return (
    <>
      {slips.length > 0 ? (
        <>
          <Title>หลักฐานการโอนเงิน</Title>
          <Transaction
            order={order}
            slip={slips[0]}
            setSlips={setSlips}
            setOrders={setOrders}
            setRemainingAmount={setRemainingAmount}
            fetchOrdersByStatus={fetchOrdersByStatus}
          />
        </>
      ) : (
        <>ไม่พบหลักฐานการโอนเงิน</>
      )}
      {slips.length > 1 ? (
        <div className="pt-4">
          <Title>หลักฐานการโอนเงินเพิ่มเติม</Title>
          {slips.map((v, i) => {
            if (i > 0) {
              return (
                <Transaction
                  key={v.id}
                  order={order}
                  slip={slips[i]}
                  setSlips={setSlips}
                  setOrders={setOrders}
                  setRemainingAmount={setRemainingAmount}
                  fetchOrdersByStatus={fetchOrdersByStatus}
                />
              )
            } else {
              return <Fragment key={v.id} />
            }
          })}
        </div>
      ) : (
        <>ไม่พบหลักฐานการโอนเงินเพิ่มเติม</>
      )}
    </>
  )
}

export default SlipsComponent

const Title = styled.h3`
  width: 100%;
  text-align: center;
  padding: 10px;
  background-color: ${Colors.LIGHT_GREY2};
`
